import {
    UPDATE_USER_NAME,
    UPDATE_PAGE_NAME,
    UPDATE_ACCOUNT_ID,
    UPDATE_DASHBOARD_URL,
    UPDATE_SIDEBAR_RESOURCE,
    UPDATE_CURRENT_PAGE
} from './types';

export const updateUserName = (userName) => (dispatch) => {
    dispatch({
        type: UPDATE_USER_NAME,
        payload: userName
    });
};

export const updateUserResource = (sidebarResource) => (dispatch) => {
    dispatch({
        type: UPDATE_SIDEBAR_RESOURCE,
        payload: sidebarResource
    });
};

export const updatePageName = (name) => (dispatch) => {
    dispatch({
        type: UPDATE_PAGE_NAME,
        payload: name
    });
};

export const updateAccountId = (accountId) => (dispatch) => {
    dispatch({
        type: UPDATE_ACCOUNT_ID,
        payload: accountId
    });
};

export const setDashboardUrl = (url) => (dispatch) => {
    dispatch({
        type: UPDATE_DASHBOARD_URL,
        payload: url
    });
};

export const setCurrentPage = (pageName) => (dispatch) => {
    dispatch({
        type: UPDATE_CURRENT_PAGE,
        payload: pageName
    });
};
